import supabase from '../supabase/supabase';

export async function getTryOnAddresses() {
  const { data, error } = await supabase.from('zevi_site_settings_20260925')
    .select('setting_value').eq('setting_key', 'try_on_addresses').maybeSingle();
  if (error) throw new Error('Try-on addresses could not be loaded.');
  return data?.setting_value || { address1: '', address2: '' };
}

export async function saveTryOnAddresses(addresses) {
  const { data, error } = await supabase.from('zevi_site_settings_20260925')
    .update({ setting_value: addresses, updated_at: new Date().toISOString() })
    .eq('setting_key', 'try_on_addresses').select('setting_key');
  if (error || !data?.length) throw new Error('Could not save addresses. Apply migration 202609250019 and check admin permissions.');
}

export async function bookTryOn({ productId, name, phone, date, time }) {
  const { data, error } = await supabase.rpc('zevi_book_try_on_20260925', {
    input_product_id: productId,
    input_name: name,
    input_phone: phone,
    input_date: date,
    input_time: time
  });
  if (error) throw new Error('Booking could not be saved. Check your details and apply migration 202609250019.');
  return data;
}

export async function getTryOnBookings() {
  const { data, error } = await supabase.from('zevi_try_on_bookings_20260925')
    .select('id,product_id,customer_name,phone,requested_date,requested_time,status,created_at')
    .order('requested_date', { ascending: true }).limit(100);
  if (error) throw new Error('Bookings could not be loaded. Apply migration 202609250019.');
  return data || [];
}

export async function updateTryOnBooking(id, status) {
  const { error } = await supabase.rpc('zevi_admin_update_try_on_20260925', {
    input_id: id, input_status: status
  });
  if (error) throw new Error('Booking status could not be saved.');
}